import _ from "lodash";
import { PrismatrisCell } from "./prismatrisCell";
import { SummaryCell } from "./summaryCell";

export class SumPercentSummaryCell extends SummaryCell {
    constructor(cells: PrismatrisCell[] | SummaryCell[], private readonly maxHundred: boolean) {
        super(cells.map(p => p.value).reduce((prev, curr) => prev + curr, 0));
    }

    static format(value: number): string {
        const val = _.isNumber(value) ? Math.round(value) : 0;
        return `${val.toLocaleString("en").replace(/,/g, " ")}%`;
    }

    validate(value: any): boolean {
        return _.isNumber(value) || !isNaN(value);
    }

    override onDelete(): void { }

    protected genHtml(): string {
        return SumPercentSummaryCell.format(this.value);
    }

    protected applyStyle(td: HTMLTableCellElement, cellProperties: any) {
        super.applyStyle(td, cellProperties);

        if (this.maxHundred && (this.value < 0 || this.value > 100)) {
            td.classList.add("hot-alert");
        }
    }
}
